import { useEffect } from 'react';

import { useFrontendLogger } from './useFrontendLogger';
import { usePublicSettings } from './usePublicSettings';
import { defaultSettings } from './useSettings';

export const useLogger = () => {
  const { data: settings } = usePublicSettings();
  const { sendToLoggingProxy } = useFrontendLogger();

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (event.message?.includes('ResizeObserver')) {
        return;
      }

      sendToLoggingProxy(
        {
          severity: 'ERROR',
          message: event.message,
          stack: event.error?.stack,
          metadata: {
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
          },
        },
        settings.loggingProxyUrl,
      );
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      sendToLoggingProxy(
        {
          severity: 'ERROR',
          message: `Unhandled Promise Rejection: ${event.reason}`,
          stack: event.reason?.stack,
        },
        settings.loggingProxyUrl,
      );
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [sendToLoggingProxy]);

  const logError = (error: Error, metadata?: Record<string, any>) => {
    sendToLoggingProxy(
      {
        severity: 'ERROR',
        message: error.message,
        stack: error.stack,
        metadata,
      },
      settings.loggingProxyUrl,
    );
    if (!defaultSettings.isProd) {
      // eslint-disable-next-line no-console
      console.error('Error:', error);
    }
  };

  return { logError };
};
